import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENV_CONFIG } from '@digilize/shared/utils/tokens';
import { EnvConfig, MovieShow } from '@shared/definitions';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ShowsService {
  private readonly baseUrl = `${this.config.api}/v1.0/shows`;

  constructor(@Inject(ENV_CONFIG) private readonly config: EnvConfig, private readonly client: HttpClient) {}

  /**
   * Prefetched during HTML parse by the inline script in the three `index.*.html` files and claimed by
   * `BootstrapPrefetchInterceptor`, which matches this URL and its `pos` param literally. Change either
   * and the head start is silently lost — the call just runs normally — so keep the three index files
   * and the interceptor in sync. See `application/bootstrap-prefetch.ts`.
   */
  getShow(showId: string, posId: string): Observable<MovieShow> {
    return this.client.get<MovieShow>(`${this.baseUrl}/${showId}`, {
      params: {
        pos: posId,
      },
    });
  }
}
